module.exports = __webpack_public_path__ + "img/careers-white.029d9e68.svg";